import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { userStyles } from "../styles";
import {
  WithStyles,
  withStyles,
  TableHead,
  Paper,
  Grid,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import ACLService from "../../acl/services/aclService";
import { withRouter } from 'react-router-dom';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import _ from "lodash";
interface UserDataProps extends WithStyles<typeof userStyles> {
  currentPage: number;
  headers: any;
  data: any;
  action: any;
  userData: any;
  history: any;
  isPostExpiryDays: any,
  showLicenseExpiredDialog: any,
  toggleLicenseExpiredDialog: any,
  setLoggedInUser: any,
}
class UserTable extends Component<UserDataProps> {
  state = {
    currentPage: 1,
    headers: null,
    data: null,
    action: null,
  };

  constructor(props: any) {
    super(props);
    let { currentPage, headers, data, action } = props;
    this.setState(
      {
        currentPage: currentPage,
        headers: headers,
        data: data,
        action: action,
      },
      () => {
        this.renderTable();
      }
    );
  }

  componentDidMount(){
    this.props.setLoggedInUser();
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    return {
      currentPage: nextProps.currentPage,
      headers: nextProps.headers,
      data: nextProps.data,
      action: nextProps.action,
    };
  }

  handleEditUser(redirectTo: any){
    if (this.props.isPostExpiryDays) {
      this.props.toggleLicenseExpiredDialog(true)
    } else {
      this.props.history.push(redirectTo);
    }
  }

  render() {
    const { classes, currentPage } = this.props;

    let table = this.renderTable(
      currentPage,
      this.state.headers,
      this.state.data,
      this.state.action
    );

    return <>{table}</>;
  }

  renderTable = (
    currentPage?: any,
    headers?: any,
    data?: any,
    action?: any
  ) => {
    const { classes } = this.props;
    let headersJSX = this.renderHeaders(this.state.headers, this.state.action);
    let dataJSX = this.renderData(
      currentPage,
      this.state.data,
      this.state.action
    );
    let table = (
      <Table classes={{ root: classes.table }} padding="checkbox">
        <TableHead classes={{ root: classes.tableHead }}>
          <TableRow>{headersJSX}</TableRow>
        </TableHead>
        <TableBody>{dataJSX}</TableBody>

        <TableBody />
      </Table>
    );
    return table;
  };

  renderHeaders = (headers: any, action: any) => {
    const { classes } = this.props;

    let headerCells =
      headers !== null &&
      headers.map((header: any, index: any) => {
        return (
          <TableCell
            key={index}
            classes={{ head: classes.textSM, root: classes.tableCell }}
            align="center"
          >
            {header}
          </TableCell>
        );
      });

    return headerCells;
  };

  renderData = (currentPage: any, data: any, action: any) => {
    const { classes } = this.props;
    const userD: any = ACLService.getUserDetailsFromStorage();
    const loggedInEmail =  userD && userD.authenticatedUser.email;
    const pageNumber = (currentPage - 1) * 10;
    let dataRows =
      data.length !== 0 &&
      data.map((record: any, index: any) => {
        const allClients=_.get(record,'clients',[]);
         const allClientsNames=allClients.map((client:any)=>{
           return client.name;
         }).join(' ,');
        return (
          <TableRow key={record._id} classes={{ root: classes.tableRow }}>
            <TableCell
              key={record._id}
              classes={{ root: classes.tableCell }}
              component="th"
              scope="row"
              align="center"
            >
              {pageNumber + index + 1}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {record.empCode && record.empCode ? record.empCode : "-"}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {record.email}
              {record.email && record.email.length > 20 && (
                <Grid className="tooltip">
                  {record.email}
                </Grid>
              )}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {allClientsNames}
              {allClientsNames && allClientsNames.length > 20 && (
                <Grid className="tooltip">
                  {allClientsNames}
                </Grid>
              )}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {record.firstName
                ? `${record.firstName} ${record.lastName}`
                : "-"}
              {record.firstName && (record.firstName.length + (record.lastName && record.lastName.length)) > 20 && (
                <Grid className="tooltip">
                  {`${record.firstName} ${record.lastName}`}
                </Grid>
              )}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {record.roleDetails && record.roleDetails.role ? record.roleDetails.role : "-"}
              {record.roleDetails &&
                record.roleDetails.role &&
                record.roleDetails.role.length > 20 && (
                  <Grid className="tooltip">{record.roleDetails.role}</Grid>
                )}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {record.isActive ? "Active" : "Inactive"}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {ACLService.checkModulePermission("user", "edit") && (
                <Grid
                  style={{color: '#1D7DEA', cursor: 'pointer' }}
                  className={loggedInEmail === record.email ? classes.disable : ''}
                  onClick = {() => loggedInEmail === record.email ? '' : this.handleEditUser(`${action.editURL}${record._id}`)}
                >
                  Edit
                </Grid>
              )}
              {!ACLService.checkModulePermission("user", "edit") && (
                <span className={classes.disable}>Edit</span>
              )}
            </TableCell>
          </TableRow>
        );
      });
    return dataRows;
  };
}

const mapStateToProps = (state: any) => ({
  userData: state.loginData.userData,
  showLicenseExpiredDialog:  state.loginData.userData &&  state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays:  state.loginData.userData &&  state.loginData.userData.isPostExpiryDays
});

const mapDispatchToProps = {
  toggleLicenseExpiredDialog,
  setLoggedInUser
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(withRouter(UserTable)));
